import { render } from "./PpmFactDialog.vue?vue&type=template&id=7feed0d0&scoped=true"
import script from "./PpmFactDialog.vue?vue&type=script&lang=js"
export * from "./PpmFactDialog.vue?vue&type=script&lang=js"

import "./PpmFactDialog.vue?vue&type=style&index=0&id=7feed0d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7feed0d0"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBtn,QSpinner,QIcon,QTooltip,QChip,QInput,QBadge});qInstall(script, 'directives', {ClosePopup});
